module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterHeadA",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Miss Nightingale")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Mollie Nightingale had fallen for the Hotel Riviera the first day she saw it. She’d fallen for its simplicity: “like a country house by the sea,” she’d said, amazed by her luck. And she’d fallen for Lola, who always had a welcoming smile, even though she was so busy. Of course Patrick had never bothered to waste his charm on his guests, he’d saved that for other women, and in fact for the past couple of years, he’d hardly been around. And now he was gone. If it were not for Lola’s obvious pain, Miss Nightingale would have said “good riddance to bad rubbish,” but she hated to see Lola hurting like this.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hadn’t wanted to bring up the matter of Patrick’s infidelity, because she knew if a woman chose to close her eyes to that sort of thing, there was nothing anyone could do about it. But now Patrick had gone missing, and she for one was not surprised. What she was surprised about, though, was that he’d simply left his hotel without making any claims on it. As husband and wife, Lola and Patrick must own the place together, which seemed unfair to Miss Nightingale, who believed that Lola had created the Hotel Riviera, as surely as she believed that God had created man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lola always treated her like a favorite aunt, well, great-aunt was more like it, she supposed, because though she hated to admit it, she was getting on in years. Seventy-eight was the exact number, though Lola was too polite to ask and Miss Nightingale was too vain to tell. And if you thought that meant she was old, then you didn’t know that inside she still felt like a spring chicken. Her brain was still as sharp as it had been when she was headmistress of Queen Wilhelmina’s Day School for Girls, in London.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She and Lola rarely exchanged much personal information, so today’s confidences had come as a surprise. Usually, they just talked about the weather, a subject about which there could be no controversy, or about food and wine, or the places Miss Nightingale had discovered on her travels up and down the coast on her rented silver Vespa.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had found many out-of-the-way places that even Lola had never visited, such as the tumbledown villa near Cap-Ferrat that had once been a hotel, owned by an exotic turn-of-the-century French singer and beauty by the name of Leonie Bhari. Now, Lola was nothing like the famed Leonie in looks, but with her “villa hotel” on the Côte d’Azur and her disastrous relationships with men, Miss Nightingale thought there were distinct similarities.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By now too, Miss Nightingale thought of the Hotel Riviera as her home away from home, though in fact she had started out as the “daughter of the manor” in the village of Blakelys, in the very heart of the English Cotswolds.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Times and circumstances had changed, and now she lived alone in what had once been the head gardener’s cottage in the village her family had once owned, with just her yappy Yorkie, Little Nell, for company on the long winter evenings, and her memories of her beloved husband, Tom, to make her smile, and her monthlong stay at the Hotel Riviera to look forward to at the end of summer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was enough, she thought, taking another sip of pastis, smiling as the other guests began to show up for dinner. Though it didn’t exercise her brain very much, and she missed that the way she missed her Tom.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d79163c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312308094_ch04.vue
// module id = 78
// module chunks = 0